module.exports = __webpack_public_path__ + "static/media/gg.6d36584f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gg.svg
// module id = 653
// module chunks = 0